import geolocationIconMapper from '@/geolocation/icons';
import { getRegion } from '@/utilities/getters/cookieGetters';
import { useTranslation } from 'react-i18next';
import DownloadPluginSteps from './DownloadSteps';
import '@/routes/Plugin/styles/index.scss';

const DownloadPlugin = () => {
  const { t } = useTranslation();
  const region = getRegion();

  const regulator = t(`regulators.${region}`);
  const regionText = t(`regions.${region}`);

  const confirmDownload = t('downloadPlugin.confirmLocation', {
    regulator,
    region: regionText,
  });

  const CountryMap = geolocationIconMapper['USA'];

  return (
    <div className="download-plugin-wrapper">
      <div className="download-plugin-content">
        <CountryMap />
        <div className="download-plugin-instructions">
          <h1 className="title">{t('downloadPlugin.instructionTitle')}</h1>
          <p>{confirmDownload}</p>
          <p>{t('downloadPlugin.pluginInstall')}</p>
          <p>{t('downloadPlugin.noNeedConnected')}</p>
        </div>
        <DownloadPluginSteps />
      </div>
    </div>
  );
};

export default DownloadPlugin;
